<template>
  <DialogModal :show="show" :title="''" @close-modal="emit('close')">
    <div class="flex justify-between items-center mb-4">
      <div class="flex justify-between items-center space-x-2">
        <div class="w-8 h-8">
          <InfoIcon width="100%" height="100%" :class="[section.optional ? 'text-secondary' : 'text-red-500']" />
        </div>
        <h1 class="font-bold text-normal leading-6" :class="[section.optional ? 'text-secondary' : 'text-red-500']">
          {{ section.optional ? 'Info' : 'Achtung' }}
        </h1>
      </div>
      <div class="w-8 h-8 cursor-pointer flex items-center justify-center" @click="emit('close')">
        <span class="w-4 h-4">
          <XIcon class="text-slate-500" />
        </span>
      </div>
    </div>
    <div class="border bottom-[1px] border-slate-200 -mx-8 mb-10" />
    <div class="m-4">
      <h3 class="font-semibold text-3xl leading-9">
        Möchtest du die
        <span v-if="section.optional">optionale</span>
        <span v-else>erforderliche</span>
        Sektion wirklich löschen?
      </h3>

      <p v-if="!section.optional" class="mb-10 font-normal leading-4 text-slate-500">
        Um Regelungslücken zu vermeiden, raten wir davon ab, diese Sektion zu löschen.
      </p>
      <div class="flex space-x-4">
        <LSButton type="secondary" variant="outline" @click="emit('close')">Nicht löschen</LSButton>
        <LSButton type="danger" @click="emit('submit')">Sektion löschen</LSButton>
      </div>
    </div>
  </DialogModal>
</template>

<script setup lang="ts">
import InfoIcon from '@/assets/icons/50/info.svg?component'
import XIcon from '@/assets/icons/24/X.svg?component'
import DialogModal from '@/components/DialogModal.vue'
import LSButton from '@/components/LSButton.vue'

import type { LegalDocumentSection } from '@/questionnaire/types'

defineProps<{ section: LegalDocumentSection; show: boolean }>()
const emit = defineEmits<{ submit: []; close: [] }>()
</script>
